module.exports = __webpack_public_path__ + "static/img/lab3.105ebd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/lab3.png
// module id = bLSa
// module chunks = 2